'use client';
import { jsx } from 'react/jsx-runtime';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

function _object_without_properties(t, e) {
    if (null == t) return {};
    var r, o, n = _object_without_properties_loose(t, e);
    if (Object.getOwnPropertySymbols) {
        var l = Object.getOwnPropertySymbols(t);
        for(o = 0; o < l.length; o++)r = l[o], !(e.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(t, r) && (n[r] = t[r]);
    }
    return n;
}
function _object_without_properties_loose(t, e) {
    if (null == t) return {};
    var r, o, n = {}, l = Object.keys(t);
    for(o = 0; o < l.length; o++)r = l[o], e.indexOf(r) >= 0 || (n[r] = t[r]);
    return n;
}
const ClearAllButton = renderWithRef('ClearAllButton', null, (r, o)=>{
    var { children: n } = r;
    return jsx(RenderComp, {
        root: "button",
        forwardedRef: o,
        classNames: [
            'swan-link',
            'swan-clear-all-button'
        ],
        props: _object_without_properties(r, [
            "children"
        ]),
        children: n
    });
});

export { ClearAllButton };
